import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';
import { CheckedInService } from 'src/app/users/services/checked-in.service';
import { takeUntil } from 'rxjs/operators';
import { MasterService } from '../../services/master.service';

@Component({
  selector: 'app-pending-bills-payment-success',
  templateUrl: './pending-bills-payment-success.component.html',
  styleUrls: ['./pending-bills-payment-success.component.scss'],
})
export class PendingBillsPaymentSuccessComponent implements OnInit {
  parameters;
  public success = true;
  public transactionDate = '';
  public Items: any;
  constructor(
    private globalService: GlobalService,
    private router: Router,
    private checkedInService: CheckedInService,
    private masterService:MasterService,
    
  ) {}

  ngOnInit(): void {
    const today = new Date();
    const date = today.getDate();
    const year = today.getFullYear();
    const month = today.toLocaleString('default', { month: 'short' });
    const time = today.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
    this.transactionDate = `${date} ${month}, ${year} ${time}`;

    const storedItems = localStorage.getItem('Items');

    if (storedItems) {
      // Parse the stored JSON string back into an object
      this.Items = JSON.parse(storedItems);
      // Now you can access the Items object
    }
    const currentUrl = window.location.href;
    this.parameters = new URL(currentUrl).searchParams;
     const worldLine =this.parameters.get("hostedCheckoutId");
    if(worldLine){
    this.worldLineStatus()
    return
    }
    const amount = this.parameters.get('amount');
    const currency = this.parameters.get('currency');
    const HotelId = this.parameters.get('HotelId');
    const payingMethod = this.parameters.get('paymentBy');
    const failed = this.parameters.get('failed');

    const paymentId = this.parameters.get('paymentId');
    const token = this.parameters.get('token');
    const PayerID = this.parameters.get('PayerID');
    const Items = this.Items;
    if (payingMethod == 'stripe') {
      this.stripePaymentGetDetails(currentUrl);
    } else if (failed) {
      this.paymentFailed();
    } else {
      this.pendingPaypalCheckout(currentUrl);
    }
  }
  paymentFailed() {
    this.success = false;
    this.transactionDate = '----';
    // this.orderId = '----';
    // this.tableNumber = '----'
  }
  worldLineStatus(){
    this.globalService.showLoader = true;
    const data = {
      HostedCheckoutId: this.parameters.get("hostedCheckoutId"),
      // paymentMethodeId
    }
    this.masterService.getHostedCheckoutStatus(data)
    .pipe(takeUntil(this.globalService.componentDestroyed(this)))
    .subscribe(
      response => {
        // if(response.Data.length > 0){
          
        // }
         if (response.Data ) {
          const paymentData = response.Data;
         const paymentStatus=paymentData.PaymentStatus
         this.success= paymentStatus == 'CAPTURED'||'PAID'|| 'COMPLETED'|| 'PENDING_CAPTURE' ? true : false;
         this.globalService.showLoader = false;
        }
          else{
            this.globalService.showLoader = false;
          }
     
      },
      error => {
        this.globalService.showLoader = false;
        this.success=false;
        this.globalService.handleApiError(error);
      }
    );
  }
  stripePaymentGetDetails(url) {
    const currentUrl = window.location.href;
    this.parameters = new URL(currentUrl).searchParams;
    const amount = this.parameters.get('amount');
    const currency = this.parameters.get('currency');
    const HotelId = this.parameters.get('HotelId');
    const payingMethod = this.parameters.get('paymentBy');
    const failed = this.parameters.get('failed');

    const paymentId = this.parameters.get('paymentId');
    const token = this.parameters.get('token');
    const PayerID = this.parameters.get('PayerID');
    const Items = this.Items;
    if (payingMethod != 'stripe') {
      this.pendingPaypalCheckout(url);
    }

    // const data = {

    // Id:UserId,
    // LangKey:this.globalService.gethotelLangTranslate()
    // }
  }

 pendingPaypalCheckout(url) {
    const currentUrl = window.location.href;
    this.parameters = new URL(currentUrl).searchParams;
    const amount = this.parameters.get('amount');
    const currency = this.parameters.get('currency');
    const HotelId = this.parameters.get('HotelId');
    const payingMethod = this.parameters.get('paymentBy');
    const failed = this.parameters.get('failed');

    const paymentId = this.parameters.get('paymentId');
    const token = this.parameters.get('token');
    const PayerID = this.parameters.get('PayerID');
    const Items = this.Items;
    if (payingMethod == 'stripe') {
      this.stripePaymentGetDetails(url);
    }
    const data = {
      amount: amount,
      currency: currency,
      HotelId: HotelId,
      Items: Items,
      token: token,
      paymentId: paymentId,
      payerId: PayerID,
    };
    this.checkedInService
      .PendingPaypalCheckout(data)
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
         
          // this.bookingId = response.Data.bookingId;
          this.router.navigate(['/guest/pending-bill-payment/success']);
          this.globalService.showLoader = false;
          // this.continue = true;
        },
        (error) => {
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }
  GoToServicesPage(){
    this.router.navigate(['hotel-services'])
  }
  ngOnDestroy() {}
}
